import React from 'react';
import { Box, Typography } from '@mui/material';
import { edgeMetaChanges } from './agentDiff';
import GroupedStatusList from './GroupedStatusList';
import MetaChangesTable from './MetaChangesTable';

function edgeLabel(edge, nodesById) {
  const src = nodesById.get(edge.source)?.data?.label || edge.source;
  const tgt = nodesById.get(edge.target)?.data?.label || edge.target;
  return `${src} → ${tgt}`;
}

export default function EdgeDiffList({ edges, nodesById }) {
  return (
    <GroupedStatusList
      title="Canvas edges"
      items={edges}
      renderItem={(e) => {
        const edge = e.newEdge || e.oldEdge;
        const changes = e.status === 'changed' ? edgeMetaChanges(e.oldEdge, e.newEdge) : [];
        return (
          <Box key={e.id} sx={{ bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 1.5, px: 1.5, py: 0.75 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 600, textDecoration: 'underline' }}>{edgeLabel(edge, nodesById)}</Typography>
            <MetaChangesTable changes={changes} />
          </Box>
        );
      }}
    />
  );
}
